moduleViewApp.factory("itemsContentService", ['$rootScope', '$q', 'DebugHelper', 'ItemsResource', ($rootScope, $q, DebugHelper, ItemsResource) ->
  $scope = $rootScope.$new()

  DebugHelper.register("itemsContentService", $scope)

  _.assignIn $scope,
    items: []
    setId: null

    fetchItems: (set_id) ->
      if parseInt(set_id) != $scope.setId
        $scope.reset()
        $scope.setId = parseInt(set_id)

      unless $scope.deferred
        $scope.deferred = $q.defer()

      if $scope.items.length > 0
        $scope.deferred.resolve($scope.items)
      else
        ItemsResource.query { set_id: set_id }
        , (success) ->
          $scope.items = success.response
          $scope.deferred.resolve($scope.items)
      
      $scope.deferred.promise
      
    reset: () ->
      $scope.items = []
      $scope.deferred = null
])
